<ng-container *ngIf="url">
  <img [src]="url" [attr.alt]="alt" #img [class.loaded]="loaded" [class.error-image]="url === imageNotFoundPath" (load)="onImageLoaded()" (error)="onImageError()">
  <div class="placeholder" *ngIf="!loaded">
  </div>
  <ion-icon *ngIf="showEnlargeIcon" name="expand-outline"></ion-icon>
</ng-container>
